import classNames from "classnames";
import React, { useState } from "react";
import styles from "./radio-button.module.scss";

export type RadioButtonItem = {
  value: string;
  label: string;
};

export type RadioButtonProps = {
  name: string;
  options: RadioButtonItem[];
  selected?: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

const RadioButton = React.forwardRef<HTMLInputElement, RadioButtonProps>(
  (
    {
      name,
      options,
      selected,
      onValueChange,
      disabled = false,
      ...props
    }: RadioButtonProps,
    ref
  ) => {
    const [checked, setChecked] = useState<string | null>(
      selected ? selected : null
    );
    const onClick = (item: RadioButtonItem) => {
      if (!disabled) {
        setChecked(item.value);
        onValueChange(item.value);
      }
    };

    return (
      <div className={styles.options}>
        {options.map((opt, index) => (
          <div
            key={opt.value}
            className={classNames(styles.option, {
              [styles.disabled]: disabled,
            })}
            onClick={() => onClick(opt)}
          >
            <input
              id={`radio-button-${name}-${index}`}
              name={name}
              type="radio"
              checked={checked === opt.value}
              value={opt.value}
              className={styles.input}
              disabled={disabled}
              ref={ref}
              {...props}
            />
            <label
              className={classNames(styles.label, {
                [styles.disabled]: disabled,
              })}
              htmlFor={`radio-button-${name}-${index}`}
            >
              {opt.label}
            </label>
          </div>
        ))}
      </div>
    );
  }
);

export default RadioButton;
